const CardContentsDetail = () => {
  return (
    <>cardContentsDetail</>
  )
}
export default CardContentsDetail
